export default __webpack_public_path__ + "static/Suspended Liceneses-b66cf6c8f568f31afd5b51dd24de4a0c.png";